
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ShuffleMaps/Explore",
      function () {
        return require("private-next-pages/ShuffleMaps/Explore.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ShuffleMaps/Explore"])
      });
    }
  